import React from 'react';

const RatingStars = ({label, value}) => {
  const rating = Math.max(0, Math.min(5, Math.round((Number(value) || 0) * 2) / 2));
  const fullStars = Math.floor(rating);
  const halfStar = rating % 1 === 0.5;
  return <span role='img' aria-label={`${label}: ${rating} out of 5`}
    style={{color: 'var(--br-warning-text)', whiteSpace: 'nowrap'}}>
    {'★'.repeat(fullStars)}
    {halfStar && <span style={{position: 'relative', display: 'inline-block'}}>
      ☆<span style={{position: 'absolute', left: 0, width: '50%', overflow: 'hidden'}}>★</span>
    </span>}
    {'☆'.repeat(5 - Math.ceil(rating))}
  </span>;
};

export default RatingStars;
